import Script from 'next/script';
export function RaptorScript() {
    return <Script id="Raptor" type="text/javascript" strategy="lazyOnload" src="/js/raptor.js" />;
}
